/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CloudProvidersEnum } from './cloudProvidersEnum';


export interface OAuthAppInventoryMetadata { 
    /**
     * VCDR or VMCFS deployment id
     */
    deployment_id?: string;
    cloud_providers?: CloudProvidersEnum;
    /**
     * Deployment region
     */
    region?: string;
    /**
     * Provider Id
     */
    provider_id?: string;
    /**
     * Agent component id
     */
    agent_id?: string;
    /**
     * VCenter site name
     */
    resource_name?: string;
    /**
     * VCenter site FQDN
     */
    resource_fqdn?: string;
    /**
     * DRC component id
     */
    drc_id?: string;
    /**
     * VMC Org Id. For inline SDDC this will be same as org id. For pool mode this is VMCA org id.
     */
    vmc_org_id?: string;
}
export namespace OAuthAppInventoryMetadata {
}


